const getTypes = storeName => ({
    INITIALIZE: `${storeName}.INITIALIZE`,
    AFTER_INITIALIZE: `${storeName}.INITIALIZED`,
    AFTER_STEP_VALIDATION: `${storeName}.AFTER_STEP_VALIDATION`,
    SET_INITIAL_DATA: `${storeName}.SET_INITIAL_DATA`,
    RESET_DATA: `${storeName}.RESET_DATA`,
    RESET_FORM_DATA: `${storeName}.RESET_FORM_DATA`,

    SUBMIT: `${storeName}.SUBMIT`,
    LOAD_METADATA: `${storeName}.LOAD_METADATA`,
    SET_DATA_FIELD: `${storeName}.SET_DATA_FIELD`,
    INITIALIZE_DATA_FIELD_VALUE: `${storeName}.INITIALIZE_DATA_FIELD_VALUE`,
    SET_DATA_FIELD_VALUE: `${storeName}.SET_DATA_FIELD_VALUE`,
    SET_DATA_FIELD_VALUES: `${storeName}.SET_DATA_FIELD_VALUES`,
    SET_DATA_FIELD_TYPE: `${storeName}.SET_DATA_FIELD_TYPE`,
    ADD_DATA_FIELD_LINK: `${storeName}.ADD_DATA_FIELD_LINK`,
    SET_DATA_FIELD_ERROR: `${storeName}.SET_DATA_FIELD_ERROR`,
    SET_DATA_FIELD_TYPE_ERROR: `${storeName}.SET_DATA_FIELD_TYPE_ERROR`,
    SET_STEP_DATA_CHECKER: `${storeName}.SET_STEP_DATA_CHECKER`,
    SET_FOCUSED: `${storeName}.SET_FOCUSED`,
    SET_UNFOCUSED: `${storeName}.SET_UNFOCUSED`,

    SET_DATA: `${storeName}.SET_DATA`,
    SET_METADATA: `${storeName}.SET_METADATA`,
    ADD_FIELD_ITEM: `${storeName}.ADD_FIELD_ITEM`,
    REMOVE_FIELD_ITEM: `${storeName}.REMOVE_FIELD_ITEM`,
    SET_STEP: `${storeName}.SET_STEP`,
    SET_SINGLE_ERROR_MODE: `${storeName}.SET_SINGLE_ERROR_MODE`,
    SET_STEP_BACK: `${storeName}.SET_STEP_BACK`,
    SET_IS_CONSTRAINT_VALID: `${storeName}.SET_IS_CONSTRAINT_VALID`,
    SET_VALIDATION_FAILED: `${storeName}.SET_VALIDATION_FAILED`,

    SET_LOADING: `${storeName}.SET_LOADING`,
    SET_STEP_VALIDATION_LOADING: `${storeName}.SET_STEP_VALIDATION_LOADING`,
    SET_GLOBAL_MESSAGE: `${storeName}.SET_GLOBAL_MESSAGE`,
    SET_ERRORS_TEXT: `${storeName}.SET_ERRORS_TEXT`,
    FOCUS_FIELD: `${storeName}.FOCUS_FIELD`,
    BLUR_FIELD: `${storeName}.BLUR_FIELD`,
    TOUCH_FIELD: `${storeName}.TOUCH_FIELD`,
    SET_SUBMIT_URL: `${storeName}.SET_SUBMIT_URL`,
    SET_SUBMIT_METHOD: `${storeName}.SET_SUBMIT_METHOD`,
    SET_SUCCESS_REDIRECT_LINK: `${storeName}.SET_SUCCESS_REDIRECT_LINK`,
    SET_SCROLL_TO_FIELD: `${storeName}.SET_SCROLL_TO_FIELD`,
    DATA_FIELD_VALIDATION_DONE: `${storeName}.DATA_FIELD_VALIDATION_DONE`,

    SHOW_ADDRESS_SUGGESTIONS_LIST: `${storeName}.SHOW_ADDRESS_SUGGESTIONS_LIST`,
    HIDE_ADDRESS_SUGGESTIONS_LIST: `${storeName}.HIDE_ADDRESS_SUGGESTIONS_LIST`,
    SELECT_ADDRESS_SUGGESTION: `${storeName}.SELECT_ADDRESS_SUGGESTION`,

    SET_ADDRESS_VALIDATION: `${storeName}.SET_ADDRESS_VALIDATION`,
    SET_NESTED_ADDRESS_VALIDATION: `${storeName}.SET_NESTED_ADDRESS_VALIDATION`,
    ADDRESS_VERIFICATION_FAILED_DIALOG: `${storeName}.ADDRESS_VERIFICATION_FAILED_DIALOG`,
    ADDRESS_NESTED_VERIFICATION_FAILED_DIALOG: `${storeName}.ADDRESS_NESTED_VERIFICATION_FAILED_DIALOG`,
    CHANGE_ADDRESS_FIELD: `${storeName}.CHANGE_ADDRESS_FIELD`,
    FORM_SUBMITTED: `${storeName}.FORM_SUBMITTED`,

    UPDATE_CONSTRAINTS: `${storeName}.UPDATE_CONSTRAINTS`,
    SET_DATA_FIELD_READONLY_STATUS: `${storeName}.SET_DATA_FIELD_READONLY_STATUS`,
    SET_DATA_FIELD_DISABLED_STATUS: `${storeName}.SET_DATA_FIELD_DISABLED_STATUS`,
    DISABLE_STEP1_BUTTON: `${storeName}.DISABLE_STEP1_BUTTON`,
    SET_LOYALTY_FLAG: `${storeName}.SET_LOYALTY_FLAG`,
});

export default getTypes;
